export var validatePhone = function (value, ignoreEmptyString) {
    var isValid = (ignoreEmptyString && (value === null || value === void 0 ? void 0 : value.toString()) === "") || !!(value === null || value === void 0 ? void 0 : value.toString());
    var message = value ? ((value === null || value === void 0 ? void 0 : value.toString()) + " is not a valid phone number.") : ('Please provide a valid phone number.');
    return isValid || {
        isValid: isValid,
        message: message
    };
};
